export class SingleTopicApp {

    constructor() {
        e5.console.log("[eventfive.helmholtz.earth] [SingleTopicApp]");

        this.init();
    }


    private _items: AnimationItem[] = [];

    private async init() {

        document.querySelectorAll<HTMLElement>(".hh-teaser__animation").forEach(
            (element) => {
                this._items.push(new AnimationItem(element));
            });

        document.documentElement.ownerDocument.addEventListener("scroll", () => this.updateByScroll(), { passive: true });
        document.body.addEventListener("scroll", () => this.updateByScroll(), { passive: true });
        window.addEventListener("resize", () => this.updateByScroll(), { passive: true });
        this.updateByScroll();
    }

    private updateByScroll(): void {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        const h = window.innerHeight;
        const w = window.innerWidth;
        const half = h * 0.5;
        let range = (h * 0.9) * 0.5;
        // let range = (h * 0.9) * 0.5;

        for (const item of this._items) {
            const bnds = item.element.getBoundingClientRect();
            let top = bnds.top + bnds.height * 0.5;


            item.active = Math.abs(top - half) < range;

            // item.seek(Math.abs(top - half) / range);
        }
    }

}

class AnimationItem {
    private _active: boolean = false;
    private _loaded: boolean = false;
    private _url: string;
    private _player: LottiePlayer;

    constructor(public readonly element: HTMLElement) {
        this._url = element.getAttribute("data-url");
    }

    public get active(): boolean {
        return this._active;
    }

    private _seek: number = 0;
    public seek(v: number): void {

        v = e5.Calc.clamp(v, 0, 1);
        if (this._seek === v) {
            return;
        }
        this._seek = v;

        if (!this._loaded) {
            this._loaded = true;
            this.load();
        }

        this._player.seek(((1 - v) * 99).toFixed(0) + "%");
        this._player.pause();
    }

    private _timeout: any = null;
    public set active(value: boolean) {
        if (this._active == value) {
            return;
        }
        this._active = value;
        this.element.classList.toggle("hh-teaser__animation--active", value);

        if (this._active && !this._loaded) {
            this._loaded = true;
            this.load();
        }
        else if (this._player) {


            this._player.setDirection(value ? 1 : -1);
            this._player.play();
            // console.dir(this._player.getLottie());
        }

        // clearTimeout(this._timeout);
        // this._timeout = setTimeout(() => {
        //     
        // }, 500);
    }

    private async load() {
        const player = document.createElement("lottie-player") as LottiePlayer;
        player.classList.add("hh-teaser__lottie");
        // player.controls = true;
        player.loop = false;
        player.autoplay = true;
        player.src = this._url;
        // player.mode = "normal";
        // player.src = this._url;
        // player.style.width = "320px";

        player.addEventListener("freeze", () => {
            if (this._active) {
                this._player.seek("100%");
            } else {
                this._player.seek("0%");
            }
        });
        this._player = player;
        this.element.appendChild(player);


        // console.log("AHH", this._url);
        // await player.load(this._url);

        // console.log("LOADED");
    }
}

document.addEventListener("DOMContentLoaded",
    () => {
        new SingleTopicApp();
    }
);